export default "/images/37fc3081769a2eac19c7ac06790176ed.avif";